import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import { useLocation, useNavigate } from "react-router-dom";
import { searchFlights } from "../services/services";
import { toast } from "react-toastify";
import { toastCSS } from "../services/commonHandler";
import NoFlight from "./assets/img/noFlight.png";
import flatpickr from "flatpickr";
import axios from "axios";
const API_URL =
  "https://raw.githubusercontent.com/mwgg/Airports/master/airports.json";

const NoFlights = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = location.state || {};
  const [airports, setAirports] = useState([]);
  const [isClosed, setIsClosed] = useState(false);
  const [errors, setErrors] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchData, setSearchData] = useState(
    location.state?.searchData || {}
  );
  const [minReturnDate, setMinReturnDate] = useState(null);
  const [showFromDropdown, setShowFromDropdown] = useState(false);
  const [filteredFromOptions, setFilteredFromOptions] = useState([]);
  const [filteredToOptions, setFilteredToOptions] = useState([]);
  const [showToDropdown, setShowToDropdown] = useState(false);
  const [passengerDropdownVisible, setPassengerDropdownVisible] =
    useState(false);
  const [fromLocation, setFromLocation] = useState(
    searchParams.fromLocation || ""
  );
  const [activeField, setActiveField] = useState(null);
  const formRef = useRef(null);
  const [toLocation, setToLocation] = useState(searchParams.toLocation || "");

  const [selectedFromIATA, setSelectedFromIATA] = useState(
    searchParams.selectedFromIATA || ""
  );
  const [selectedToIATA, setSelectedToIATA] = useState(
    searchParams.selectedToIATA || ""
  );

  const [departureDate, setDepartureDate] = useState(
    searchParams.departureDate || ""
  );
  const [returnDate, setReturnDate] = useState(searchParams.returnDate || "");

  const [isRoundTrip, setIsRoundTrip] = useState(
    searchParams.isRoundTrip || false
  );

  const [seatClass, setSeatClass] = useState(searchParams.seatClass || "");

  const [passengerCounts, setPassengerCounts] = useState({
    adults: searchParams.passengerCounts?.adults || 1,
    children: searchParams.passengerCounts?.children || 0,
    infants: searchParams.passengerCounts?.infants || 0,
  });

  const [childrenAges, setChildrenAges] = useState(
    searchParams.childrenAges ||
      new Array(searchParams.passengerCounts?.children || 0).fill("")
  );
  const [sortedFlights, setSortedFlights] = useState({
    recommended: [],
    fastest: [],
    cheapest: [],
  });
  const [convertedPrices, setConvertedPrices] = useState({
    recommended: {},
    fastest: {},
    cheapest: {},
  });
  const seatClassOptions = ["Economy", "Business", "First", "Premium Economy"];
  console.log("Search Data to Store:", searchData, searchParams); // Debugging

  useEffect(() => {
    const fetchAirports = async () => {
      try {
        const response = await axios.get(API_URL);
        const airportData = response.data;

        // Convert object to array and filter airports with valid IATA codes
        const airportList = Object.values(airportData).filter(
          (airport) => airport.iata
        );
        setAirports(airportList);
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    };
    fetchAirports();
  }, []);
  const validateForm = () => {
    const newErrors = {};
    // if (!fromLocation) {
    //   newErrors.fromLocation = "Please select departure airport";
    // }

    // if (!toLocation) {
    //   newErrors.toLocation = "Please select arrival airport";
    // } else if (
    //   fromLocation &&
    //   toLocation &&
    //   selectedFromIATA === selectedToIATA
    // ) {
    //   newErrors.toLocation = "Arrival airport cannot be same as departure";
    // }
    if (!selectedFromIATA) {
      newErrors.fromLocation = "Please select departure airport from list";
    }
    if (!selectedToIATA) {
      newErrors.toLocation = "Please select arrival airport from list";
    } else if (
      selectedFromIATA &&
      selectedToIATA &&
      selectedFromIATA === selectedToIATA
    ) {
      newErrors.toLocation = "Arrival airport cannot be same as departure";
    }
    if (!departureDate) {
      newErrors.departureDate = "Please select departure date";
    } else if (new Date(departureDate) < new Date().setHours(0, 0, 0, 0)) {
      newErrors.departureDate = "Departure date cannot be in the past";
    }

    if (isRoundTrip) {
      if (!returnDate) {
        newErrors.returnDate = "Please select return date";
      } else if (new Date(returnDate) < new Date(departureDate)) {
        newErrors.returnDate = "Return date must be after departure date";
      }
    }

    if (passengerCounts.adults < 1) {
      newErrors.passengers = "At least 1 adult is required";
    } else if (passengerCounts.infants > passengerCounts.adults) {
      newErrors.passengers = "Cannot have more infants than adults";
    }

    // Seat class validation
    if (!seatClass) {
      newErrors.seatClass = "Please select seat class";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSearchFlights = async () => {
    if (!validateForm()) {
      return;
    }
    setIsLoading(true);
    // Prepare data payload
    const requestData = {
      adults: passengerCounts.adults,
      childs: passengerCounts.children,
      infants: passengerCounts.infants,
      journeyType: isRoundTrip ? 2 : 1,
      class: seatClass,
      preferredCarriers: [],
      childrenAges: childrenAges,
      fare_type: "1",
      routes: [
        {
          origin: selectedFromIATA,
          destination: selectedToIATA,
          departureDate: departureDate,
        },
      ],
      page: 1,
      limit: 15,
    };
    if (isRoundTrip) {
      requestData.routes.push({
        origin: selectedToIATA,
        destination: selectedFromIATA,
        departureDate: returnDate,
      });
    }

    const searchData = {
      fromLocation: fromLocation,
      toLocation: toLocation,
      departureDate: departureDate,
      returnDate: returnDate,
      passengerCounts: {
        adults: passengerCounts.adults,
        children: passengerCounts.children,
        infants: passengerCounts.infants,
      },
      seatClass: seatClass,
      isRoundTrip: isRoundTrip,
      journeyType: isRoundTrip ? 2 : 1,
      selectedFromIATA: selectedFromIATA,
      selectedToIATA: selectedToIATA,
      page: 1,
      limit: 15,
    };

    localStorage.setItem("flightSearchData", JSON.stringify(searchData));

    // Call the searchFlights service function
    await searchFlights(
      requestData,
      (response) => {
        setIsLoading(false);
        if (response?.code === 400) {
          toast.success(response?.message, toastCSS);
          navigate("/NoFlights", {
            state: {
              ...searchData,
              errorMessage:
                response.error?.message ||
                response?.message ||
                "Something went wrong with flight booking.",
            },
          });
          return;
        }
        if (isRoundTrip) {
          // Navigate to DepartureReturnFlights for round trips
          localStorage.removeItem("latestRoundFlightResult");
          const latestResult = {
            flights: response?.AirSearchResponses,
            allFlights: response.data?.AirSearchResponses || [],
            totalCount: response?.totalCount || 0,
            searchData: searchData,
          };
          localStorage.setItem(
            "latestRoundFlightResult",
            JSON.stringify(latestResult)
          );
          navigate("/RoundFlight", {
            state: {
              flights: response.AirSearchResponses,
              allFlights: response.data?.AirSearchResponses,
              totalCount: response.totalCount,
              searchData: searchData,
              currency: response.data.Currency || "MYR",
            },
          });
        } else {
          // Navigate to FlightList for one-way trips
          navigate("/FlightList", {
            state: {
              flights: response.AirSearchResponses,
              allFlights: response.data?.AirSearchResponses,
              totalCount: response.totalCount,
              searchData: searchData,
              // currency: response.data.Currency || "USD",
            },
          });
        }
      },
      (error) => {
        setIsLoading(false);
        console.error("Error searching flights:", error);
        navigate("/NoFlights", {
          state: {
            ...searchData,
            errorMessage: "Search failed",
          },
        });
        // toast.error("Failed to search flights. Please try again.",{
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,});
      }
    );
  };
  const handleToggle = () => {
    setIsClosed(!isClosed);
  };
  const handleTripTypeChange = (isRound) => {
    setIsRoundTrip(isRound);
    setActiveField(null);
    if (!isRound) {
      setReturnDate(null);
      setMinReturnDate(null);
    } else if (departureDate) {
      const nextDay = new Date(departureDate);
      nextDay.setDate(nextDay.getDate());
      setMinReturnDate(nextDay);
    }
  };

  const searchAirports = (query) => {
    const q = query.toLowerCase().trim();
    if (q.length < 2) return [];

    const results = [];
    for (let i = 0; i < airports.length; i++) {
      const a = airports[i];

      if (
        a.iata?.toLowerCase().startsWith(q) ||
        a.city?.toLowerCase().includes(q) ||
        a.name?.toLowerCase().includes(q)
      ) {
        results.push(a);
        if (results.length === 12) break; // 🔥 limit
      }
    }
    return results;
  };
  const handleFromLocationChange = (e) => {
    const value = e.target.value;
    setFromLocation(value);
    setSelectedFromIATA("");
    if (value.trim().length >= 2) {
      const matches = searchAirports(value);
      setFilteredFromOptions(matches);
      setShowFromDropdown(matches.length > 0);
    } else {
      setShowFromDropdown(false);
    }
  };
  const handleToLocationChange = (e) => {
    const value = e.target.value;
    setToLocation(value);
    setSelectedToIATA("");

    if (value.trim().length >= 2) {
      const matches = searchAirports(value);
      setFilteredToOptions(matches);
      setShowToDropdown(matches.length > 0);
    } else {
      setShowToDropdown(false);
    }
  };

  // const handleFromLocationChange = (e) => {
  //     const inputValue = e.target.value;
  //     setFromLocation(inputValue);

  //     if (inputValue.length > 1) {
  //         const filtered = airports.filter(
  //             (airport) =>
  //                 airport.city.toLowerCase().includes(inputValue.toLowerCase()) ||
  //                 airport.iata.toLowerCase().includes(inputValue.toLowerCase()) ||
  //                 airport?.name.toLowerCase().includes(inputValue.toLowerCase())
  //         );
  //         setFilteredFromOptions(filtered);
  //         setShowFromDropdown(true);
  //     } else {
  //         setShowFromDropdown(false);
  //     }
  // };
  const handleSelectFromLocation = (airport) => {
    setFromLocation(`${airport.city} (${airport.iata})`);
    setSelectedFromIATA(airport.iata);
    setShowFromDropdown(false);
  };

  // const handleToLocationChange = (e) => {
  //     const inputValue = e.target.value;
  //     setToLocation(inputValue);

  //     if (inputValue.length > 1) {
  //         const filtered = airports.filter(
  //             (airport) =>
  //                 airport.city.toLowerCase().includes(inputValue.toLowerCase()) ||
  //                 airport.iata.toLowerCase().includes(inputValue.toLowerCase()) ||
  //                 airport?.name.toLowerCase().includes(inputValue.toLowerCase())
  //         );
  //         setFilteredToOptions(filtered);
  //         setShowToDropdown(true);
  //     } else {
  //         setShowToDropdown(false);
  //     }
  // };
  const handleSelectToLocation = (airport) => {
    setToLocation(`${airport.city} (${airport.iata})`);
    setSelectedToIATA(airport.iata);
    setShowToDropdown(false);
  };
  const updateCount = (type, increment) => {
    setPassengerCounts((prevCounts) => {
      const newCount = Math.max(0, prevCounts[type] + increment);
      if (type === "children") {
        setChildrenAges((prevAges) => {
          // Add new age inputs if needed
          if (newCount > prevAges.length) {
            return [...prevAges, ...Array(newCount - prevAges.length).fill("")];
          }
          // Remove extra inputs when decreasing count
          return prevAges.slice(0, newCount);
        });
      }
      return { ...prevCounts, [type]: newCount };
    });
  };
  const getDisplayText = () => {
    const { adults, children, infants } = passengerCounts;
    const parts = [
      adults > 0 ? `${adults} Adult${adults > 1 ? "s" : ""}` : "",
      children > 0 ? `${children} Child${children > 1 ? "ren" : ""}` : "",
      infants > 0 ? `${infants} Infant${infants > 1 ? "s" : ""}` : "",
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(", ") : "Select Passengers";
  };
  const handleChildAgeChange = (index, value) => {
    setChildrenAges((prevAges) => {
      const updatedAges = [...prevAges];
      updatedAges[index] = value;
      return updatedAges;
    });
  };
    const handleSwapLocations = () => {
    if (!fromLocation && !toLocation) return;

    const tempFrom = fromLocation;
    const tempFromIATA = selectedFromIATA;

    setFromLocation(toLocation);
    setSelectedFromIATA(selectedToIATA);

    setToLocation(tempFrom);
    setSelectedToIATA(tempFromIATA);

    setShowFromDropdown(false);
    setShowToDropdown(false);
  };
  const clearAll = () => {
    setPassengerCounts({ adults: 0, children: 0, infants: 0 });
  };
  const saveSelection = () => {
    setPassengerDropdownVisible(false); // Close the dropdown after saving
  };
  useEffect(() => {
    // Initialize Flatpickr separately for each field
    flatpickr("#departure-datepicker", {
      dateFormat: "Y-m-d",
      minDate: "today",
      allowInput: true,
      onChange: (selectedDates, dateStr) => {
        setDepartureDate(dateStr);
        if (isRoundTrip && selectedDates[0]) {
          const nextDay = new Date(selectedDates[0]);
          nextDay.setDate(nextDay.getDate());
          setMinReturnDate(nextDay);
          returnPicker.set("minDate", nextDay);

          if (returnDate && new Date(returnDate) < selectedDates[0]) {
            setReturnDate(null);
            returnPicker.clear();
          }
        }
      },
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["S", "M", "T", "W", "T", "F", "S"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
      },
    });

    const returnPicker = flatpickr("#return-datepicker", {
      dateFormat: "Y-m-d",
      minDate: minReturnDate || "today",
      allowInput: true,
      onChange: (selectedDates, dateStr) => setReturnDate(dateStr),
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["S", "M", "T", "W", "T", "F", "S"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
      },
    });
    return () => {
      // departurePicker.destroy();
      // returnPicker.destroy();
    };
  }, [isRoundTrip, minReturnDate]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (formRef.current && !formRef.current.contains(e.target)) {
        setActiveField(null);
        setShowFromDropdown(false);
        setShowToDropdown(false);
        setPassengerDropdownVisible(false);
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className={`topResFrm ${isClosed ? "closed" : ""}`} ref={formRef}>
          <div className="topResFrmWrap">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="topCtaWrap">
                    <button
                      className={!isRoundTrip ? "btn active" : "btn"}
                      onClick={() => handleTripTypeChange(false)}
                    >
                      One-way
                    </button>
                    <button
                      className={isRoundTrip ? "btn active" : "btn"}
                      onClick={() => handleTripTypeChange(true)}
                    >
                      Round trip
                    </button>
                    {/* <button className="btn">Multi-city</button> */}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <form>
                    <ul className="formList">
                      <li className="sixth posRel">
                        <div
                          className={`inputField ${
                            fromLocation ? "filled" : ""
                          } ${activeField === "from" ? "active" : ""}`}
                          onClick={() => setActiveField("from")}
                        >
                          <label>From</label>
                          <div className="icoInputWrap">
                            <div className="icoWrap">
                              <svg
                                width="33"
                                height="23"
                                viewBox="0 0 33 23"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.56495 14.1034C3.56409 14.1039 3.56315 14.1043 3.5622 14.1049C3.21622 14.2847 3.06595 14.7002 3.21725 15.0597C3.36898 15.4205 3.7727 15.6036 4.14403 15.48L14.613 11.9969L12.6555 15.1936C12.5133 15.4258 12.5433 15.7244 12.729 15.9236C12.9147 16.1228 13.2104 16.1738 13.4522 16.0481L15.5051 14.9814C15.564 14.9508 15.6175 14.9107 15.6635 14.8626L21.7451 8.50978L29.2507 4.59352C32.0932 3.06119 31.7639 1.88327 31.5953 1.55885C31.4646 1.30728 31.1724 0.969974 30.5232 0.79161C29.8646 0.610669 28.9749 0.625104 27.8036 0.835772C27.4126 0.906052 27.1968 0.900123 26.9683 0.893851C26.1649 0.871857 25.6199 0.925726 22.914 2.33176L8.11468 10.0226L2.37543 7.04404C2.15901 6.93174 1.90152 6.93183 1.68509 7.04438L0.718012 7.54699C0.518942 7.65044 0.37675 7.83765 0.330527 8.05717C0.284303 8.27677 0.338947 8.50548 0.479335 8.68032L4.46278 13.6419L3.56495 14.1034Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M30.8194 20.1309H2.80156C2.01371 20.1309 1.375 20.7697 1.375 21.5574C1.375 22.3451 2.01371 22.984 2.80156 22.984H30.8194C31.6072 22.984 32.246 22.3453 32.246 21.5574C32.2459 20.7695 31.6072 20.1309 30.8194 20.1309Z"
                                  fill="#000000"
                                />
                              </svg>
                            </div>
                            <div className="dropdown dropdownHt">
                              <input
                                type="text"
                                id="from-location"
                                placeholder="Start typing City or Airport"
                                value={fromLocation}
                                required
                                onFocus={() => {
                                  setActiveField("from");
                                  setShowFromDropdown(true);
                                  // setFilteredFromOptions(airports);
                                }}
                                onChange={(e) => {
                                  handleFromLocationChange(e);
                                  setActiveField(null);
                                }}
                              />
                              {errors.fromLocation && (
                                <span className="error">
                                  {errors.fromLocation}
                                </span>
                              )}
                              {showFromDropdown &&
                                filteredFromOptions.length > 0 && (
                                  <ul className="dropdown-menu">
                                    {filteredFromOptions.map(
                                      (airport, index) => (
                                        <li
                                          key={index}
                                          onClick={() =>
                                            handleSelectFromLocation(airport)
                                          }
                                          className={
                                            fromLocation ===
                                            `${airport.city} (${airport.iata})`
                                              ? "selected"
                                              : ""
                                          }
                                        >
                                          {airport.city} ({airport.iata})
                                          <div className="optionSub">
                                            {airport.name}
                                          </div>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                )}
                            </div>
                          </div>
                        </div>
                        <button className="btn btnReverse"
                          type="button"
                          onClick={handleSwapLocations}
                          title="Swap locations"
                          >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="20"
                            height="20"
                            x="0"
                            y="0"
                            viewBox="0 0 24 24"
                          >
                            <g>
                              <g
                                fill="#FFFFFF"
                                fillRule="evenodd"
                                clipRule="evenodd"
                              >
                                <path
                                  d="M12.595 4.507a.75.75 0 0 1 1.058-.072l5.84 5.09A.75.75 0 0 1 19 10.842H5a.75.75 0 0 1 0-1.5h11.998l-4.33-3.776a.75.75 0 0 1-.073-1.058zM11.405 19.493a.75.75 0 0 1-1.058.072l-5.84-5.09A.75.75 0 0 1 5 13.158h14a.75.75 0 0 1 0 1.5H7.002l4.33 3.776a.75.75 0 0 1 .073 1.058z"
                                  fill="#FFFFFF"
                                  opacity="1"
                                  data-original="#FFFFFF"
                                ></path>
                              </g>
                            </g>
                          </svg>
                        </button>
                      </li>
                      <li className="sixth">
                        <div
                          className={`inputField ${
                            toLocation ? "filled" : ""
                          } ${activeField === "to" ? "active" : ""}`}
                          onClick={() => setActiveField("to")}
                        >
                          <label>To</label>
                          <div className="icoInputWrap">
                            <div className="icoWrap">
                              <svg
                                width="33"
                                height="24"
                                viewBox="0 0 33 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1.95755 7.53175C1.95649 7.53166 1.95552 7.53148 1.95437 7.5313C1.55853 7.46615 1.1786 7.7157 1.08163 8.10535C0.984214 8.49598 1.20397 8.89571 1.58602 9.02283L12.3572 12.6066L8.77421 14.0334C8.51397 14.1371 8.35468 14.4016 8.38491 14.68C8.41496 14.9585 8.6272 15.1828 8.9038 15.2283L11.2525 15.6149C11.32 15.6259 11.3887 15.6259 11.4562 15.6147L20.3821 14.1301L28.979 15.5304C32.2653 16.0203 32.7201 14.8472 32.7812 14.4758C32.8286 14.188 32.7959 13.7299 32.3709 13.1829C31.94 12.6278 31.198 12.0914 30.1034 11.5429C29.7378 11.3597 29.5638 11.2218 29.3796 11.0758C28.7313 10.5624 28.2489 10.2708 25.1534 9.76121L8.2212 6.9744L5.32937 0.983023C5.22029 0.75708 5.00814 0.598407 4.76045 0.557656L3.65398 0.37547C3.42618 0.337989 3.19361 0.404553 3.02035 0.556949C2.84692 0.709346 2.75092 0.931399 2.75887 1.16203L2.98208 7.70456L1.95755 7.53175Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M31.1595 20.3496H2.33298C1.52238 20.3496 0.865234 21.0067 0.865234 21.8173C0.865234 22.6279 1.52238 23.285 2.33298 23.285H31.1595C31.9701 23.285 32.6274 22.6277 32.6274 21.8173C32.6274 21.0068 31.9701 20.3496 31.1595 20.3496Z"
                                  fill="#000000"
                                />
                              </svg>
                            </div>
                            <div className="dropdown dropdownHt">
                              <input
                                type="text"
                                id="to-location"
                                placeholder="Start typing City or Airport"
                                value={toLocation}
                                required
                                onFocus={() => {
                                  setActiveField("to");
                                  setShowToDropdown(true);
                                  // setFilteredToOptions(airports); // Show all options initially
                                }}
                                onBlur={() =>
                                  setTimeout(
                                    () => setShowToDropdown(false),
                                    150
                                  )
                                }
                                onChange={(e) => {
                                  handleToLocationChange(e);
                                  setActiveField(null);
                                }}
                              />
                              {errors.toLocation && (
                                <span className="error">
                                  {errors.toLocation}
                                </span>
                              )}
                              {showToDropdown &&
                                filteredToOptions.length > 0 && (
                                  <ul className="dropdown-menu">
                                    {filteredToOptions.map((option, index) => (
                                      <li
                                        key={index}
                                        onMouseDown={(e) => {
                                          e.stopPropagation();
                                          handleSelectToLocation(option);
                                        }}
                                        className={
                                          toLocation ===
                                          `${option.city} (${option.iata})`
                                            ? "selected"
                                            : ""
                                        }
                                      >
                                        {option.city} ({option.iata})
                                        <div className="optionSub">
                                          {option.name}
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="sixth">
                        <div
                          className={`inputField ${
                            departureDate ? "filled" : ""
                          } ${activeField === "departure" ? "active" : ""}`}
                          onClick={() => setActiveField("departure")}
                        >
                          <label>Departure Date</label>
                          <div className="icoInputWrap">
                            <div className="icoWrap">
                              <svg
                                width="30"
                                height="29"
                                viewBox="0 0 30 29"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M21.9336 17.2808C22.6684 17.2808 23.264 16.6851 23.264 15.9503C23.264 15.2155 22.6684 14.6198 21.9336 14.6198C21.1988 14.6198 20.6031 15.2155 20.6031 15.9503C20.6031 16.6851 21.1988 17.2808 21.9336 17.2808Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M21.9336 22.6027C22.6684 22.6027 23.264 22.007 23.264 21.2722C23.264 20.5374 22.6684 19.9418 21.9336 19.9418C21.1988 19.9418 20.6031 20.5374 20.6031 21.2722C20.6031 22.007 21.1988 22.6027 21.9336 22.6027Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M16.6117 15.9503C16.6117 16.6851 16.016 17.2808 15.2812 17.2808C14.5464 17.2808 13.9507 16.6851 13.9507 15.9503C13.9507 15.2155 14.5464 14.6198 15.2812 14.6198C16.016 14.6198 16.6117 15.2155 16.6117 15.9503Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M16.6117 21.2722C16.6117 22.007 16.016 22.6027 15.2812 22.6027C14.5464 22.6027 13.9507 22.007 13.9507 21.2722C13.9507 20.5374 14.5464 19.9418 15.2812 19.9418C16.016 19.9418 16.6117 20.5374 16.6117 21.2722Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M8.62877 17.2808C9.36358 17.2808 9.95925 16.6851 9.95925 15.9503C9.95925 15.2155 9.36358 14.6198 8.62877 14.6198C7.89397 14.6198 7.29829 15.2155 7.29829 15.9503C7.29829 16.6851 7.89397 17.2808 8.62877 17.2808Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M8.62877 22.6027C9.36358 22.6027 9.95925 22.007 9.95925 21.2722C9.95925 20.5374 9.36358 19.9418 8.62877 19.9418C7.89397 19.9418 7.29829 20.5374 7.29829 21.2722C7.29829 22.007 7.89397 22.6027 8.62877 22.6027Z"
                                  fill="#000000"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M8.62877 0.982422C9.17988 0.982422 9.62663 1.42918 9.62663 1.98028V2.99506C10.5074 2.97812 11.4778 2.97813 12.545 2.97814H18.0172C19.0844 2.97813 20.0549 2.97812 20.9357 2.99506V1.98028C20.9357 1.42918 21.3825 0.982422 21.9336 0.982422C22.4847 0.982422 22.9314 1.42918 22.9314 1.98028V3.0807C23.2773 3.10707 23.6048 3.14022 23.9147 3.18188C25.4746 3.3916 26.7371 3.83348 27.7328 4.82916C28.7285 5.82484 29.1704 7.0874 29.3801 8.64728C29.5839 10.163 29.5838 12.0996 29.5838 14.5447V17.3559C29.5838 19.8009 29.5839 21.7377 29.3801 23.2533C29.1704 24.8132 28.7285 26.0758 27.7328 27.0715C26.7371 28.0672 25.4746 28.509 23.9147 28.7187C22.399 28.9225 20.4623 28.9225 18.0172 28.9225H12.5452C10.1001 28.9225 8.16335 28.9225 6.64766 28.7187C5.08778 28.509 3.82522 28.0672 2.82954 27.0715C1.83385 26.0758 1.39198 24.8132 1.18226 23.2533C0.978479 21.7376 0.978495 19.801 0.978516 17.3559V14.5448C0.978495 12.0997 0.978479 10.163 1.18226 8.64728C1.39198 7.0874 1.83385 5.82484 2.82954 4.82916C3.82522 3.83348 5.08778 3.3916 6.64766 3.18188C6.95756 3.14022 7.28507 3.10707 7.63091 3.0807V1.98028C7.63091 1.42918 8.07767 0.982422 8.62877 0.982422ZM6.91358 5.15981C5.575 5.33977 4.80379 5.67728 4.24072 6.24035C3.67765 6.80342 3.34015 7.57463 3.16018 8.91321C3.1297 9.1399 3.10422 9.37856 3.08291 9.63054H27.4794C27.4581 9.37856 27.4326 9.1399 27.4022 8.91321C27.2222 7.57463 26.8847 6.80342 26.3216 6.24035C25.7585 5.67728 24.9873 5.33977 23.6488 5.15981C22.2815 4.97598 20.4791 4.97386 17.9421 4.97386H12.6202C10.0832 4.97386 8.28087 4.97598 6.91358 5.15981ZM2.97424 14.6198C2.97424 13.4836 2.97466 12.4947 2.99165 11.6263H27.5707C27.5877 12.4947 27.5881 13.4836 27.5881 14.6198V17.2808C27.5881 19.8178 27.586 21.6201 27.4022 22.9874C27.2222 24.326 26.8847 25.0972 26.3216 25.6603C25.7585 26.2234 24.9873 26.5609 23.6488 26.7408C22.2815 26.9247 20.4791 26.9268 17.9421 26.9268H12.6202C10.0832 26.9268 8.28087 26.9247 6.91358 26.7408C5.575 26.5609 4.80379 26.2234 4.24072 25.6603C3.67765 25.0972 3.34015 24.326 3.16018 22.9874C2.97635 21.6201 2.97424 19.8178 2.97424 17.2808V14.6198Z"
                                  fill="#000000"
                                />
                              </svg>
                            </div>
                            <div className="datePickerWrap">
                              <input
                                id="departure-datepicker"
                                value={departureDate}
                                required
                                onChange={(e) => {
                                  setDepartureDate(e.target.value);
                                  setActiveField(null);
                                }}
                                placeholder={
                                  activeField === "departure"
                                    ? ""
                                    : "Select Date"
                                }
                                type="text"
                              />
                              {errors.departureDate && (
                                <span className="error">
                                  {errors.departureDate}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </li>
                      {isRoundTrip && (
                        <li className="sixth">
                          <div
                            className={`inputField ${
                              returnDate ? "filled" : ""
                            } ${activeField === "return" ? "active" : ""}`}
                            onClick={() =>
                              departureDate && setActiveField("return")
                            }
                          >
                            <label>Return Date</label>
                            <div className="icoInputWrap">
                              <div className="icoWrap">
                                <svg
                                  width="30"
                                  height="29"
                                  viewBox="0 0 30 29"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M21.9336 17.2808C22.6684 17.2808 23.264 16.6851 23.264 15.9503C23.264 15.2155 22.6684 14.6198 21.9336 14.6198C21.1988 14.6198 20.6031 15.2155 20.6031 15.9503C20.6031 16.6851 21.1988 17.2808 21.9336 17.2808Z"
                                    fill="#000000"
                                  />
                                  <path
                                    d="M21.9336 22.6027C22.6684 22.6027 23.264 22.007 23.264 21.2722C23.264 20.5374 22.6684 19.9418 21.9336 19.9418C21.1988 19.9418 20.6031 20.5374 20.6031 21.2722C20.6031 22.007 21.1988 22.6027 21.9336 22.6027Z"
                                    fill="#000000"
                                  />
                                  <path
                                    d="M16.6117 15.9503C16.6117 16.6851 16.016 17.2808 15.2812 17.2808C14.5464 17.2808 13.9507 16.6851 13.9507 15.9503C13.9507 15.2155 14.5464 14.6198 15.2812 14.6198C16.016 14.6198 16.6117 15.2155 16.6117 15.9503Z"
                                    fill="#000000"
                                  />
                                  <path
                                    d="M16.6117 21.2722C16.6117 22.007 16.016 22.6027 15.2812 22.6027C14.5464 22.6027 13.9507 22.007 13.9507 21.2722C13.9507 20.5374 14.5464 19.9418 15.2812 19.9418C16.016 19.9418 16.6117 20.5374 16.6117 21.2722Z"
                                    fill="#000000"
                                  />
                                  <path
                                    d="M8.62877 17.2808C9.36358 17.2808 9.95925 16.6851 9.95925 15.9503C9.95925 15.2155 9.36358 14.6198 8.62877 14.6198C7.89397 14.6198 7.29829 15.2155 7.29829 15.9503C7.29829 16.6851 7.89397 17.2808 8.62877 17.2808Z"
                                    fill="#000000"
                                  />
                                  <path
                                    d="M8.62877 22.6027C9.36358 22.6027 9.95925 22.007 9.95925 21.2722C9.95925 20.5374 9.36358 19.9418 8.62877 19.9418C7.89397 19.9418 7.29829 20.5374 7.29829 21.2722C7.29829 22.007 7.89397 22.6027 8.62877 22.6027Z"
                                    fill="#000000"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M8.62877 0.982422C9.17988 0.982422 9.62663 1.42918 9.62663 1.98028V2.99506C10.5074 2.97812 11.4778 2.97813 12.545 2.97814H18.0172C19.0844 2.97813 20.0549 2.97812 20.9357 2.99506V1.98028C20.9357 1.42918 21.3825 0.982422 21.9336 0.982422C22.4847 0.982422 22.9314 1.42918 22.9314 1.98028V3.0807C23.2773 3.10707 23.6048 3.14022 23.9147 3.18188C25.4746 3.3916 26.7371 3.83348 27.7328 4.82916C28.7285 5.82484 29.1704 7.0874 29.3801 8.64728C29.5839 10.163 29.5838 12.0996 29.5838 14.5447V17.3559C29.5838 19.8009 29.5839 21.7377 29.3801 23.2533C29.1704 24.8132 28.7285 26.0758 27.7328 27.0715C26.7371 28.0672 25.4746 28.509 23.9147 28.7187C22.399 28.9225 20.4623 28.9225 18.0172 28.9225H12.5452C10.1001 28.9225 8.16335 28.9225 6.64766 28.7187C5.08778 28.509 3.82522 28.0672 2.82954 27.0715C1.83385 26.0758 1.39198 24.8132 1.18226 23.2533C0.978479 21.7376 0.978495 19.801 0.978516 17.3559V14.5448C0.978495 12.0997 0.978479 10.163 1.18226 8.64728C1.39198 7.0874 1.83385 5.82484 2.82954 4.82916C3.82522 3.83348 5.08778 3.3916 6.64766 3.18188C6.95756 3.14022 7.28507 3.10707 7.63091 3.0807V1.98028C7.63091 1.42918 8.07767 0.982422 8.62877 0.982422ZM6.91358 5.15981C5.575 5.33977 4.80379 5.67728 4.24072 6.24035C3.67765 6.80342 3.34015 7.57463 3.16018 8.91321C3.1297 9.1399 3.10422 9.37856 3.08291 9.63054H27.4794C27.4581 9.37856 27.4326 9.1399 27.4022 8.91321C27.2222 7.57463 26.8847 6.80342 26.3216 6.24035C25.7585 5.67728 24.9873 5.33977 23.6488 5.15981C22.2815 4.97598 20.4791 4.97386 17.9421 4.97386H12.6202C10.0832 4.97386 8.28087 4.97598 6.91358 5.15981ZM2.97424 14.6198C2.97424 13.4836 2.97466 12.4947 2.99165 11.6263H27.5707C27.5877 12.4947 27.5881 13.4836 27.5881 14.6198V17.2808C27.5881 19.8178 27.586 21.6201 27.4022 22.9874C27.2222 24.326 26.8847 25.0972 26.3216 25.6603C25.7585 26.2234 24.9873 26.5609 23.6488 26.7408C22.2815 26.9247 20.4791 26.9268 17.9421 26.9268H12.6202C10.0832 26.9268 8.28087 26.9247 6.91358 26.7408C5.575 26.5609 4.80379 26.2234 4.24072 25.6603C3.67765 25.0972 3.34015 24.326 3.16018 22.9874C2.97635 21.6201 2.97424 19.8178 2.97424 17.2808V14.6198Z"
                                    fill="#000000"
                                  />
                                </svg>
                              </div>
                              <div className="datePickerWrap">
                                <input
                                  id="return-datepicker"
                                  value={returnDate}
                                  required={isRoundTrip}
                                  onChange={(e) => {
                                    setReturnDate(e.target.value);
                                    setActiveField(null);
                                  }}
                                  placeholder="Select Date"
                                  type="text"
                                  disabled={!departureDate}
                                />
                                {errors.returnDate && (
                                  <span className="error">
                                    {errors.returnDate}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                      <li className="sixth">
                        <div
                          className={`inputField ${
                            getDisplayText() ? "filled" : ""
                          } ${activeField === "passenger" ? "active" : ""}`}
                          onClick={() => setActiveField("passenger")}
                        >
                          <label>Passanger</label>
                          <div className="icoInputWrap">
                            <div className="icoWrap">
                              <svg
                                width="22"
                                height="28"
                                viewBox="0 0 22 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11.28 0.113281C7.78965 0.113281 4.96019 2.94274 4.96019 6.43306C4.96019 9.92338 7.78965 12.7528 11.28 12.7528C14.7703 12.7528 17.5997 9.92338 17.5997 6.43306C17.5997 2.94274 14.7703 0.113281 11.28 0.113281ZM6.95591 6.43306C6.95591 4.04495 8.89185 2.109 11.28 2.109C13.6681 2.109 15.604 4.04495 15.604 6.43306C15.604 8.82117 13.6681 10.7571 11.28 10.7571C8.89185 10.7571 6.95591 8.82117 6.95591 6.43306Z"
                                  fill="#000000"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11.28 14.7486C8.56667 14.7486 6.06118 15.3749 4.19935 16.4388C2.36575 17.4866 0.96875 19.0861 0.96875 21.0683C0.96875 23.0506 2.36575 24.6501 4.19935 25.6979C6.06118 26.7618 8.56667 27.3881 11.28 27.3881C13.9933 27.3881 16.4987 26.7618 18.3606 25.6979C20.1942 24.6501 21.5912 23.0506 21.5912 21.0683C21.5912 19.0861 20.1942 17.4866 18.3606 16.4388C16.4987 15.3749 13.9933 14.7486 11.28 14.7486ZM2.96447 21.0683C2.96447 20.1114 3.65234 19.0499 5.18951 18.1716C6.69845 17.3093 8.84963 16.7443 11.28 16.7443C13.7103 16.7443 15.8615 17.3093 17.3704 18.1716C18.9076 19.0499 19.5955 20.1114 19.5955 21.0683C19.5955 22.0253 18.9076 23.0867 17.3704 23.9651C15.8615 24.8274 13.7103 25.3924 11.28 25.3924C8.84963 25.3924 6.69845 24.8274 5.18951 23.9651C3.65234 23.0867 2.96447 22.0253 2.96447 21.0683Z"
                                  fill="#000000"
                                />
                              </svg>
                            </div>
                            <div className="dropdown">
                              <input
                                type="text"
                                id="passenger-selection"
                                placeholder={
                                  activeField === "passenger"
                                    ? ""
                                    : "Select Passengers"
                                }
                                value={getDisplayText()}
                                readOnly
                                required
                                onFocus={() => {
                                  setActiveField("passenger");
                                  setPassengerDropdownVisible(true);
                                }}
                              />
                              {errors.passengers && (
                                <span className="error">
                                  {errors.passengers}
                                </span>
                              )}
                              {passengerDropdownVisible && (
                                <div className="dropdown-menu passenger-dropdown">
                                  {/* Adults */}
                                  <div className="passenger-type">
                                    <div className="leftWrap">
                                      <svg
                                        width="12"
                                        height="25"
                                        viewBox="0 0 12 25"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M2.4 3.75C2.4 1.67893 4.01178 0 6 0C7.98823 0 9.6 1.67893 9.6 3.75C9.6 5.82107 7.98823 7.5 6 7.5C4.01178 7.5 2.4 5.82107 2.4 3.75Z"
                                          fill="#808089"
                                        />
                                        <path
                                          d="M0 12.5C0 10.4289 1.61178 8.75 3.6 8.75H8.4C10.3882 8.75 12 10.4289 12 12.5V16.7923C12 17.2313 11.7788 17.6382 11.4174 17.8641L9 19.375V23.75C9 24.4404 8.46274 25 7.8 25H4.2C3.53726 25 3 24.4404 3 23.75V19.375L0.582605 17.8641C0.221159 17.6382 0 17.2313 0 16.7923V12.5Z"
                                          fill="#808089"
                                        />
                                      </svg>
                                      <label>
                                        Adults <span>12+</span>
                                      </label>
                                    </div>
                                    <div className="counter">
                                      <button
                                        className="btn btn-minus"
                                        type="button"
                                        onClick={() =>
                                          updateCount("adults", -1)
                                        }
                                      >
                                        -
                                      </button>
                                      <span>{passengerCounts.adults}</span>
                                      <button
                                        className="btn btn-plus"
                                        type="button"
                                        onClick={() => updateCount("adults", 1)}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                  {/* Children */}
                                  <div className="passenger-type">
                                    <div className="leftWrap">
                                      <svg
                                        width="13"
                                        height="20"
                                        viewBox="0 0 13 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M10.5 4C10.5 6.20914 8.70914 8 6.5 8C4.29086 8 2.50001 6.20914 2.50001 4C2.50001 1.79086 4.29086 0 6.5 0C8.70914 0 10.5 1.79086 10.5 4Z"
                                          fill="#808089"
                                        />
                                        <path
                                          d="M0.3909 7.99011C0.948646 7.37757 1.89735 7.33314 2.5099 7.89089C3.63842 8.91846 5.02338 9.5 6.5 9.5C7.97662 9.5 9.36158 8.91846 10.4901 7.89089C11.1026 7.33314 12.0514 7.37757 12.6091 7.99011C13.1668 8.60265 13.1224 9.55136 12.5099 10.1091C11.7459 10.8047 10.8788 11.3753 9.93511 11.7843L11.1021 17.9113C11.3087 18.9955 10.4775 20 9.37375 20C8.56639 20 7.86263 19.4505 7.66681 18.6673L7.12127 16.4851C7.05 16.2 6.79385 16 6.5 16C6.20615 16 5.95 16.2 5.87873 16.4851L5.33319 18.6673C5.13737 19.4505 4.43361 20 3.62625 20C2.52252 20 1.69133 18.9955 1.89785 17.9113L3.06489 11.7843C2.12119 11.3753 1.25407 10.8047 0.49012 10.1091C-0.122423 9.55136 -0.166845 8.60265 0.3909 7.99011Z"
                                          fill="#808089"
                                        />
                                      </svg>
                                      <label>
                                        Children <span>2-11 Years</span>
                                      </label>
                                    </div>
                                    <div className="counter">
                                      <button
                                        className="btn btn-minus"
                                        type="button"
                                        onClick={() =>
                                          updateCount("children", -1)
                                        }
                                      >
                                        -
                                      </button>
                                      <span>{passengerCounts.children}</span>
                                      <button
                                        className="btn btn-plus"
                                        type="button"
                                        onClick={() =>
                                          updateCount("children", 1)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                  {/* Child Age Inputs */}
                                  {passengerCounts.children > 0 && (
                                    <div className="child-age-inputs">
                                      {childrenAges.map((age, index) => (
                                        <input
                                          key={index}
                                          type="number"
                                          min="2"
                                          max="11"
                                          placeholder={`Age of child ${
                                            index + 1
                                          }`}
                                          value={age}
                                          onChange={(e) =>
                                            handleChildAgeChange(
                                              index,
                                              e.target.value
                                            )
                                          }
                                        />
                                      ))}
                                    </div>
                                  )}
                                  {/* Infants */}
                                  <div className="passenger-type marBtm0">
                                    <div className="leftWrap">
                                      <svg
                                        width="13"
                                        height="21"
                                        viewBox="0 0 13 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M10.5 4.2C10.5 6.5196 8.70914 8.4 6.5 8.4C4.29086 8.4 2.50001 6.5196 2.50001 4.2C2.50001 1.8804 4.29086 0 6.5 0C8.70914 0 10.5 1.8804 10.5 4.2Z"
                                          fill="#808089"
                                        />
                                        <path
                                          d="M0.3909 8.38962C0.948646 7.74644 1.89735 7.6998 2.5099 8.28543C3.63842 9.36439 5.02338 9.975 6.5 9.975C7.97662 9.975 9.36158 9.36439 10.4901 8.28543C11.1026 7.6998 12.0514 7.74644 12.6091 8.38962C13.1668 9.03279 13.1224 10.0289 12.5099 10.6146C11.7459 11.345 10.8788 11.944 9.93511 12.3736L11.1021 18.8069C11.3087 19.9453 10.4775 21 9.37375 21C8.56639 21 7.86263 20.423 7.66681 19.6006L7.12127 17.3093C7.05 17.01 6.79385 16.8 6.5 16.8C6.20615 16.8 5.95 17.01 5.87873 17.3093L5.33319 19.6006C5.13737 20.423 4.43361 21 3.62625 21C2.52252 21 1.69133 19.9453 1.89785 18.8069L3.06489 12.3736C2.12119 11.944 1.25407 11.345 0.49012 10.6146C-0.122423 10.0289 -0.166845 9.03279 0.3909 8.38962Z"
                                          fill="#808089"
                                        />
                                      </svg>
                                      <label>
                                        Infants <span>2 Years</span>
                                      </label>
                                    </div>
                                    <div className="counter">
                                      <button
                                        className="btn btn-minus"
                                        type="button"
                                        onClick={() =>
                                          updateCount("infants", -1)
                                        }
                                      >
                                        -
                                      </button>
                                      <span>{passengerCounts.infants}</span>
                                      <button
                                        className="btn btn-plus"
                                        type="button"
                                        onClick={() =>
                                          updateCount("infants", 1)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                  {/* Clear All */}
                                  <div className="ctaClrWrap">
                                    <button className="btn" onClick={clearAll}>
                                      Clear all
                                    </button>
                                    <button
                                      className="btn btn-save"
                                      onClick={saveSelection}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="sixth">
                        <div
                          className={`inputField ${seatClass ? "filled" : ""} ${
                            activeField === "seatClass" ? "active" : ""
                          }`}
                          onClick={() => setActiveField("seatClass")}
                        >
                          <label>Seat Class</label>
                          <div className="icoInputWrap">
                            <div className="icoWrap">
                              <svg
                                width="29"
                                height="28"
                                viewBox="0 0 29 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17.8247 16.4093H10.8397C10.7662 16.4104 10.6945 16.3876 10.6351 16.3444C10.5757 16.3013 10.5319 16.24 10.5104 16.1698L9.98149 14.4136H15.829C16.0936 14.4136 16.3474 14.3085 16.5345 14.1213C16.7217 13.9342 16.8268 13.6804 16.8268 13.4157C16.8268 13.1511 16.7217 12.8973 16.5345 12.7101C16.3474 12.523 16.0936 12.4179 15.829 12.4179H9.38278L7.84607 7.27889V4.93391C7.84607 4.00764 7.47811 3.11931 6.82314 2.46434C6.16817 1.80937 5.27984 1.44141 4.35357 1.44141C3.4273 1.44141 2.53896 1.80937 1.88399 2.46434C1.22902 3.11931 0.861058 4.00764 0.861058 4.93391V7.42856C0.845793 7.51772 0.845793 7.60883 0.861058 7.69799L4.5731 20.6702C4.71083 21.1674 5.00807 21.6057 5.41911 21.9175C5.83015 22.2294 6.33224 22.3977 6.84821 22.3965H7.35712L5.92021 26.0187C5.85989 26.1701 5.83759 26.3341 5.85528 26.4961C5.87296 26.6582 5.93008 26.8135 6.02164 26.9483C6.11321 27.0832 6.23642 27.1936 6.38052 27.2699C6.52461 27.3461 6.68519 27.3859 6.84821 27.3858H16.8268C16.9898 27.3859 17.1504 27.3461 17.2945 27.2699C17.4386 27.1936 17.5618 27.0832 17.6534 26.9483C17.7449 26.8135 17.8021 26.6582 17.8197 26.4961C17.8374 26.3341 17.8151 26.1701 17.7548 26.0187L16.3079 22.3965H17.8247C18.6186 22.3965 19.38 22.0811 19.9415 21.5197C20.5029 20.9583 20.8182 20.1968 20.8182 19.4029C20.8182 18.6089 20.5029 17.8475 19.9415 17.2861C19.38 16.7247 18.6186 16.4093 17.8247 16.4093ZM3.18607 8.42642H6.1098L7.30723 12.4179H4.31365L3.18607 8.42642ZM4.35357 3.43713C4.75054 3.43713 5.13125 3.59482 5.41196 3.87552C5.69266 4.15623 5.85036 4.53694 5.85036 4.93391V6.4307H2.85678V4.93391C2.85678 4.53694 3.01447 4.15623 3.29518 3.87552C3.57588 3.59482 3.95659 3.43713 4.35357 3.43713ZM15.33 25.39H8.345L9.54244 22.3965H14.1725L15.33 25.39ZM17.8247 20.4007H6.84821C6.77393 20.3996 6.70195 20.3748 6.64273 20.3299C6.58351 20.2851 6.54014 20.2225 6.51892 20.1513L4.8525 14.4136H7.84607L8.54458 16.7386C8.68817 17.2315 8.99157 17.6628 9.40704 17.9644C9.82251 18.2661 10.3265 18.4211 10.8397 18.405H17.8247C18.0893 18.405 18.3431 18.5102 18.5303 18.6973C18.7174 18.8844 18.8225 19.1382 18.8225 19.4029C18.8225 19.6675 18.7174 19.9213 18.5303 20.1085C18.3431 20.2956 18.0893 20.4007 17.8247 20.4007Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M25.488 0.443359H22.1352C21.2565 0.443359 20.4139 0.792395 19.7926 1.41368C19.1713 2.03497 18.8223 2.87762 18.8223 3.75625V10.1026C18.8223 10.9813 19.1713 11.8239 19.7926 12.4452C20.4139 13.0665 21.2565 13.4155 22.1352 13.4155H25.488C26.3666 13.4155 27.2092 13.0665 27.8305 12.4452C28.4518 11.8239 28.8009 10.9813 28.8009 10.1026V3.75625C28.8009 3.3212 28.7152 2.8904 28.5487 2.48846C28.3822 2.08652 28.1382 1.72131 27.8305 1.41368C27.5229 1.10605 27.1577 0.862027 26.7558 0.695538C26.3538 0.52905 25.923 0.443359 25.488 0.443359ZM22.1352 2.43908H25.488C25.8373 2.43908 26.1723 2.57785 26.4194 2.82487C26.6664 3.07189 26.8051 3.40692 26.8051 3.75625V4.4348H20.818V3.75625C20.818 3.40692 20.9568 3.07189 21.2038 2.82487C21.4508 2.57785 21.7858 2.43908 22.1352 2.43908ZM25.488 11.4198H22.1352C21.7858 11.4198 21.4508 11.281 21.2038 11.034C20.9568 10.787 20.818 10.452 20.818 10.1026V6.43052H26.8051V10.1026C26.8051 10.452 26.6664 10.787 26.4194 11.034C26.1723 11.281 25.8373 11.4198 25.488 11.4198Z"
                                  fill="#000000"
                                />
                              </svg>
                            </div>
                            <div className="dropdown">
                              <input
                                type="text"
                                id="Select-Class"
                                placeholder={
                                  activeField === "seatClass"
                                    ? ""
                                    : "Select Class"
                                }
                                value={seatClass}
                                onFocus={() => {
                                  setActiveField("seatClass");
                                  setShowDropdown(true);
                                }} // Show dropdown on focus
                                onBlur={() =>
                                  setTimeout(() => {
                                    setShowDropdown(false);
                                    setActiveField(null);
                                  }, 150)
                                }
                                onChange={(e) => setSeatClass(e.target.value)} // Update input field
                              />
                              {showDropdown && (
                                <ul className="dropdown-menu">
                                  {seatClassOptions.map((option, index) => (
                                    <li
                                      key={index}
                                      onClick={() => setSeatClass(option)} // Set selected option
                                    >
                                      {option}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="full">
                        <div className="ctaWrap">
                          <a className="btn" onClick={handleSearchFlights}>
                            Search
                          </a>
                        </div>
                      </li>
                    </ul>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="ctaToggleWrap">
                  <button
                    className="btn"
                    id="toggle-btn"
                    onClick={handleToggle}
                  >
                    <svg
                      className={isClosed ? "arrow-closed" : "arrow-open"}
                      width="35"
                      height="35"
                      viewBox="0 0 35 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24.8333 17.5L17.5 10.1667M17.5 10.1667L17.5 24.8333M17.5 10.1667L10.1667 17.5M34 17.5C34 15.3332 33.5732 13.1876 32.744 11.1857C31.9148 9.18385 30.6994 7.36491 29.1673 5.83274C27.6351 4.30058 25.8162 3.08519 23.8143 2.25599C21.8124 1.42679 19.6668 1 17.5 1C15.3332 1 13.1876 1.42679 11.1857 2.25599C9.18385 3.08519 7.36491 4.30057 5.83274 5.83274C4.30057 7.36491 3.08519 9.18385 2.25599 11.1857C1.42678 13.1876 0.999999 15.3332 0.999999 17.5C0.999998 21.8761 2.73839 26.0729 5.83274 29.1673C8.92709 32.2616 13.1239 34 17.5 34C21.8761 34 26.0729 32.2616 29.1673 29.1673C32.2616 26.0729 34 21.8761 34 17.5Z"
                        stroke="#5D5D5D"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className="loaderWrap">
            <div className="loader">
              <div className="rocket"></div>
            </div>
            <h3>Searching For Available Flights....</h3>
          </div>
        ) : (
          <></>
        )}
        <div className="noFlightAvailWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="noFlightAvailBox">
                  <div className="imgWrap">
                    <img src={NoFlight} class="img-fluid" alt="" />
                  </div>
                  <div className="dataWrap">
                    <p>
                      {" "}
                      We are sorry......... There are no flights available for
                      your chosen destination
                    </p>
                    {/* <p> We are sorry......... There are No flights available for your chosen destination</p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NoFlights;
